import { Route } from '@angular/router';
import { DynamicPromoDetailPageMatcher } from '@lentau/url-parsers/shared/url-parse-promoaction.helper';
import { resetSelectionsSessionStorageByUrlFactory } from './models/reset-filters-by-keys';

export const PROMO_DETAIL_ROUTE: Route = {
  matcher: DynamicPromoDetailPageMatcher,
  loadComponent: () => import('./promo-detail-page.component').then((m) => m.PromoDetailPageComponent),
  canDeactivate: [resetSelectionsSessionStorageByUrlFactory(/^\/action\/detail\/[^?]+/)],
};
